import Component from "../component";
import mapboxgl from "mapbox-gl";

export default class InteractiveMap extends Component {
  _limitMobile = 1000;
  _dataMap = DATA_MAP;
  _catMap = DATA_MAP_CAT;
  _aboutShowned = true;

  constructor(...args) {
    super(...args);

    this._retrieveDOM();

    this._isTouch = ENV.template == "mobile";
    this._circleColor = ["match", ["get", "color"]];
  }

  _retrieveDOM() {
    this.dom.containerMap = this.dom.component.querySelector(
      ".js-location-map-container"
    );
    this.dom.popup = this.dom.component.querySelector(".js-popup");
    this.dom.closePopup = this.dom.popup.querySelector(".js-close-popup");
    this.dom.btnCat = this.dom.component.querySelector(".js-btn-cat");
  }

  bind() {
    super.bind();

    mapboxgl.accessToken =
      "pk.eyJ1Ijoic3dlZXRwdW5rZGV2IiwiYSI6ImNsc3VrZm8wcjB2bmUycHBndXNzNG4wd20ifQ.y65GfmR8uWFjB3tvjJ0Fog";
    const map = new mapboxgl.Map({
      container: this.dom.containerMap,
      style: "mapbox://styles/sweetpunkdev/clsn1ggqr027901qy38t1g12v",
      center: [18, 10.9844589],
      zoom: ENV.device == "mobile" ? 1 : 1.5,
    });

    map.on("load", () => {
      this._listCategories();

      const nav = new mapboxgl.NavigationControl();
      map.addControl(nav, "top-right");

      map.addSource("locations", {
        type: "geojson",
        data: this._formatData(this._dataMap),
        cluster: false,
      });

      console.log(this._dataMap);
      map.addLayer({
        id: "unclustered-point",
        type: "circle",
        source: "locations",
        filter: ["!", ["has", "point_count"]],
        paint: {
          "circle-color": this._circleColor,
          "circle-radius": ["step", ["get", "point_count"], 20, 10, 30, 20, 40],
        },
      });

      map.addLayer({
        id: "unclustered-point-labels",
        type: "symbol",
        source: "locations",
        filter: ["!", ["has", "point_count"]],
        layout: {
          "text-field": ["get", "legend"],
          "text-font": ["Barlow Medium"],
          "text-size": 10,
          "text-offset": [0, -1.4],
        },
        paint: {
          "text-color": "#fff",
        },
      });

      map.on("click", "unclustered-point", (e) => {
        const coordinates = e.features[0].geometry.coordinates.slice();
        const props = e.features[0].properties;
        this.dom.popup.dataset.idPopup = props.id;
        this.dom.popup.classList.add("show");
        this.dom.popup
          .querySelector(".js-close-popup")
          .addEventListener("click", () => {
            this.dom.popup.classList.remove("show");
          });
        // Ensure that if the map is zoomed out such that
        // multiple copies of the feature are visible, the
        // popup appears over the copy being pointed to.
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }
      });

      map.on("mouseenter", "clusters", () => {
        map.getCanvas().style.cursor = "pointer";
      });
      map.on("mouseleave", "clusters", () => {
        map.getCanvas().style.cursor = "";
      });
      map.on("mouseenter", "unclustered-point", () => {
        map.getCanvas().style.cursor = "pointer";
      });
      map.on("mouseleave", "unclustered-point", () => {
        map.getCanvas().style.cursor = "";
      });

      this.dom.btnCat.addEventListener("click", () => {
        this.dom.btnCat.classList.toggle("open");
      });
    });
  }

  _formatData(data) {
    let Geojson = {
      type: "FeatureCollection",
      features: [],
    };
    if (data) {
      data.forEach((element) => {
        const _item = {
          type: "Feature",
          properties: {
            id: element.id,
            title: element.title,
            logo: element.logo,
            address: element.address,
            date: element.date,
            link: element.link,
            text: element.text,
            legend: element.legend,
            catName: element.catName,
            color: element.color,
          },
          geometry: {
            type: "Point",
            coordinates: [
              element.map_geolocation_lng,
              element.map_geolocation_lat,
            ],
          },
        };

        Geojson.features.push(_item);
      });
    }

    return Geojson;
  }

  _listCategories() {
    if (this._catMap) {
      this._catMap.forEach((cat) => {
        this._circleColor.push(cat.color);
        this._circleColor.push(cat.color);
      });
    }

    this._circleColor.push("#E75113");
  }

  /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/interactive-map/interactive-map.js